import { render, staticRenderFns } from "./pdf-viewer-gdocs.vue?vue&type=template&id=1ae9e58e&"
import script from "./pdf-viewer-gdocs.vue?vue&type=script&lang=js&"
export * from "./pdf-viewer-gdocs.vue?vue&type=script&lang=js&"
import style0 from "./pdf-viewer-gdocs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports